// import Script from 'next/script';
import React from 'react';
interface DataCoreScriptProps {
  projectName?: string;
  projectNested?: boolean;
}

export const DataCoreScript: React.FC<DataCoreScriptProps> = (props) => {
  let url = `/common-static/infra-static/data-core/data-core.latest.min.js`;

  const isLocal = process.env.NODE_ENV !== 'production';

  const isTest =
    process.env.BUILD_ENV !== 'mainnet' && process.env.BUILD_ENV !== 'testnet';

  if (isLocal || isTest)
    url =
      'https://t1.bycsi.com/common-static/infra-static/data-core/data-core.latest.min.js';

  return (
    <>
      <script
        data-index="1"
        dangerouslySetInnerHTML={{
          __html: `
        const PROJECT_TYPE = 'spot';
        const PROJECT_NAME = '${props.projectName || ''}';
        const PROJECT_NESTED = ${!!props.projectNested};`,
        }}
      />
      <script data-index="2" crossOrigin="anonymous" src={url} />
    </>
  );
};
